export default function setupAlertBanner() {
    const banner = document.querySelector('[data-alert-banner]');

    if (!banner) {
        return;
    }

    const dismissCookieName = banner.getAttribute('data-alert-banner-cookie');
    const dismissButton = banner.querySelector('[data-alert-banner-dismiss]');

    dismissButton?.addEventListener('click', () => {
        if (dismissCookieName) {
            const expires = new Date();
            expires.setDate(expires.getDate() + 180);

            document.cookie = [
                `${dismissCookieName}=dismissed`,
                `expires=${expires.toUTCString()}`,
                'path=/',
                'SameSite=Lax',
                window.location.protocol === 'https:' ? 'Secure' : '',
            ].filter(Boolean).join('; ');
        }

        banner.remove();
        window.dispatchEvent(new CustomEvent('alert-banner:updated'));
    });
}
